module.exports = __webpack_public_path__ + "static/media/2020.8.21辖区未成年人做游戏.50108905.jpg";